import React from 'react';

const Footer = () => {
  return (
    <div className="mt-20 text-center">
      <p className="text-lg text-gray-600">
        © 2025 Ứng dụng Học Tiếng Anh - NLTECH
      </p>
    </div>
  );
};

export default Footer;